import { FunnelId } from 'modules/funnels/types/funnel-interface'
import database from 'shared/db/index'

export const setSelectedFunnelStepInDB = async (funnelId: FunnelId, stepId: number) => {
  if (funnelId && stepId !== undefined) {
    await database.funnels.put({ funnelId, stepId })
  }
}

export const getFunnelStepInDB = async (funnelId: FunnelId): Promise<number | null> => {
  try {
    const funnel = await database.funnels.where({ funnelId }).first()
    return funnel ? funnel.stepId : null
  } catch (e) {
    return null
  }
}

export const updateFunnelStepInDB = async (funnelId: FunnelId, stepId: number) => {
  await database.funnels.where({ funnelId }).modify({ stepId })
}

export const removeFunnelStepInDB = async (funnelId: FunnelId) => {
  await database.funnels.where({ funnelId }).delete()
}
